import { render, staticRenderFns } from "./IconCubeTransparentSolid.vue?vue&type=template&id=4f6da49e"
import script from "./IconCubeTransparentSolid.vue?vue&type=script&lang=js"
export * from "./IconCubeTransparentSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports